import vuex from "src/vuex"
import router from "src/http/router";
import UserRole from "src/util/valueObjects/userRole";
import * as Cookies from "js-cookie";

export default (to, from, next) => {

  if(Cookies.getJSON("token").user.role.id !== UserRole.FOUR_PL.index){
    vuex.dispatch("redirectToMainMenu");
  }
  next();
};
